'use strict';

module.exports = {
    ACTION_EXECUTION_REQUEST: 'job.action.executionRequest'
};